import { cn } from "@/lib/utils";
import { Box, getBoxStyle, Resolution } from "./canvas-geometry";

type Props = {
  box: Box;
  resolution: Resolution;
  isDashed?: boolean;
};

export default function SelectionOutline({
  box,
  resolution,
  isDashed = false,
}: Props) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute outline-2 -outline-offset-2 outline-tertiary-400",
        isDashed ? "outline-dashed" : "outline-solid",
      )}
      style={getBoxStyle(box, resolution)}
    />
  );
}
